export const ResStatusIconNo: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill="#CD1F16" />
    <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="white" />
    <path
      d="M4.81802 11.182C4.00368 10.3676 3.5 9.24264 3.5 8C3.5 5.51472 5.51472 3.5 8 3.5C9.24264 3.5 10.3676 4.00368 11.182 4.81802M4.81802 11.182C5.63236 11.9963 6.75736 12.5 8 12.5C10.4853 12.5 12.5 10.4853 12.5 8C12.5 6.75736 11.9963 5.63236 11.182 4.81802M4.81802 11.182L11.182 4.81802"
      stroke="white"
      strokeWidth="1.5"
    />
  </svg>
);
